export default __webpack_public_path__ + "images/checked_e770f7.svg";